import $ from "jquery";
// require('slick-carousel');

//console.log('test merchant page');

function initCarousel () {
    let mainBookCarousel = $('.review-carousel--merchant').slick({
        adaptiveHeight: false,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        duration: 3200,
    });
}

initCarousel();

$(".widget_btn").click(function(){
    $("#sb_enterprise_widget").trigger("click");
});